"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectAttachmentPreferencesOption')(function selectAttachmentPreferencesOption(optionKey, preference, state) {
    var optionState = state.optionState;
    optionState[optionKey] = preference;
}));
//# sourceMappingURL=selectAttachmentPreferencesOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-attachment-preferences-option/lib/actions/selectAttachmentPreferencesOption.js
// module id = 4982
// module chunks = 2